import { gql } from "@urql/core";

const DepartmentListQry = gql`
  query ($input: DepartmentListInput!) {
    departments(input: $input) {
      items {
        id
        key
        name
      }
    }
  }
`;

export { DepartmentListQry };
